import React, { CSSProperties, ChangeEvent, useState } from 'react';
import Avatar, { Size, Status } from 'components/base/Avatar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import { faCamera } from '@fortawesome/free-solid-svg-icons';
import { Member } from 'data/members';
import { getSasTokenAsync } from 'data/storage';
import { BlobServiceClient } from '@azure/storage-blob';

interface AvatarUploadProps {
  size: Size;
  src: string;
  member?: Member | null;
  className?: string;
  status?: Status;
  thumbnail?: boolean;
  onChange?: (member: Member) => void;
}

const AvatarUpload = ({
  size,
  src,
  member,
  status,
  thumbnail,
  onChange,
  className
}: AvatarUploadProps) => {
  const [image, setImage] = useState<File | null>(null);

  const handleChange = async (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && member) {
      const updateMember = { ...member };
      try {
        const sasToken = await getSasTokenAsync();

        const storageAccountName = 'nupitchstorage';
        const containerName = 'nupitch-test-blob-container';

        const blobServiceClient = new BlobServiceClient(
          `https://${storageAccountName}.blob.core.windows.net${sasToken}`
        );
        const containerClient =
          blobServiceClient.getContainerClient(containerName);

        const originalFileName = e.target.files[0].name;
        const fileExtension = originalFileName.split('.').pop(); // Extract the file extension
        const newFileName = `nupitch_${updateMember.id}_1_avatar_img.${fileExtension}`; // Append the file extension to the new filename

        const file = e.target.files[0];

        // Create a new BlockBlobClient with the new file name
        const blockBlobClient = containerClient.getBlockBlobClient(newFileName);

        // Upload the file
        await blockBlobClient.uploadData(file);

        // Get the base URL without the SAS token
        const blobUrl = blockBlobClient.url.split('?')[0];

        // Update the member's avatar with the blob URL
        updateMember.avatar = blobUrl;
      } catch (error) {
        console.error('Error uploading image:', error);
      }

      if (onChange) {
        onChange(updateMember); // Pass the updated member object to the onChange handler
      }

      setImage(e.target.files[0] || null);
    }
  };
  return (
    <div className={classNames('d-inline-flex', className)}>
      <input
        className="d-none"
        id="avatarFile"
        type="file"
        accept="image/*"
        onChange={handleChange}
      />
      <label
        className="cursor-pointer hover-actions-trigger"
        htmlFor="avatarFile"
      >
        <Avatar
          size={size}
          status={status}
          src={image ? URL.createObjectURL(image) : src}
          thumbnail={thumbnail}
        />
        <div
          className="h-100 w-100 bg-black light position-absolute top-0 rounded-circle justify-content-center align-items-center hover-actions"
          style={{ '--phoenix-bg-opacity': 0.56 } as CSSProperties}
        >
          <FontAwesomeIcon icon={faCamera} className="text-300 w-30 h-30" />
        </div>
      </label>
    </div>
  );
};

export default AvatarUpload;
